var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"qr-code"},[_c('div',{attrs:{"id":_vm.index != 0 ? ("qrcode-" + _vm.index) : 'qrcode'}})])}
var staticRenderFns = []

export { render, staticRenderFns }